export enum GalleryBrowseEnum {
  previous = -1,
  none = 0,
  next = 1,
}
